import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import StyledLink from "./styling/Link.styles";
import useViewport from "../../../hooks/useViewport";
import { LinkProps } from "./Link.types";
import { TypographyVariantOptions } from "../../typography/Typography/Typography.types";

const typographyVariantMapping: {
	sm: TypographyVariantOptions;
	md: TypographyVariantOptions;
	lg: TypographyVariantOptions;
} = {
	sm: "body-small",
	md: "body",
	lg: "body-large",
};

const Link: FC<LinkProps> = ({
	size = "md",
	colorOn = "bg_white",
	className,
	inline = true,
	...props
}) => {
	const block = new BemIt("Link");
	const vp = useViewport();

	return (
		<StyledLink
			className={addClass(className).after(block.mod(size))}
			size={typographyVariantMapping[size]}
			inline={inline}
			colorOn={colorOn}
			viewport={vp}
			{...props}
		>
			{props.children}
		</StyledLink>
	);
};

export default Link;
